import React, { useState, useEffect } from "react"
import styled from "styled-components"
import { color } from "../../../configs/utilities"
import { window } from "browser-monads"

const ButtonScrollToTop = ({ showBelow = 500 }) => {
  const [isVisible, setIsVisible] = useState(false)

  const handleScroll = () => {
    if (window.scrollY > showBelow) {
      setIsVisible(true)
    } else {
      setIsVisible(false)
    }
  }

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    })
  }

  useEffect(() => {
    window.addEventListener("scroll", handleScroll)

    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])

  return <div>{isVisible && <Button onClick={scrollToTop}>↑</Button>}</div>
}

export default ButtonScrollToTop

const Button = styled.button`
  width: 50px;
  height: 50px;
  position: fixed;
  bottom: 30px;
  right: 30px;
  padding: 10px 10px;
  font-size: 16px;
  background-color: ${color.yellow};
  color: ${color.white};
  border: none;
  border-radius: 50%;
  cursor: pointer;
  z-index: 1000;
  font-weight: 600;
`
